module.exports = __webpack_public_path__ + "static/media/no-tasks.95067cdf.svg";